<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header">
            <div slot="header"><i class="icon-layers"></i> Office Modules</div>
            <div class="d-flex flex-row mb-5">
							<div class="col-2">
								Select Office
							</div>
							<div class="col-6">
								<multiselect @input="fetchVersionModuleData()" v-model="value"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</div>
						</div>
						<div class="d-flex flex-row-reverse mb-2">
							<div class="col-md-2">
								<b-button variant="primary" class="float-right" size="md" @click="saveConfiguration"><i
									class="fa fa-save"></i> Save
								</b-button>
							</div>
						</div>
						<table class="table table-hover table-striped table-bordered table-small table-fixed" v-if="moduleList.length >0">
							<thead>
							<tr>
								<th class="text-center">Code</th>
								<th class="text-left">Description</th>
								<th class="text-center">Selected</th>
								<th class="text-center">Included</th>
							</tr>
							</thead>
							<tbody>
								<tr v-for="module in moduleList" :key="module.code" class="text-center">
									<td>{{module.code}}</td>
									<td class="text-left">{{module.description}}</td>
									<td>
										<input type="checkbox" id="module.code" v-model="module.selected">
									</td>
									<td>{{module.includedInVersion ? 'Yes' : 'No'}}</td>
								</tr>
							</tbody>
						</table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import officeService from '@/services/officeService'
import toastService from '@/services/toastService'

export default {
  name: 'modules',
	components:{Multiselect},
	data() {
  	return{
  		value:"",
			officeList :[],
			moduleList : [],
		}
	},
	methods:{
  	fetchVersionModuleData(){
  		officeService.getModuleListForOffice(this.value.id,r => {
  			this.moduleList = r, e => toastService.showErrorToast(e)
			});
		},
		saveConfiguration(){
  		let request = {
  			modules : this.moduleList
			};
			officeService.updateModuleListForOffice(this.value.id,request,
				r => {
					this.moduleList = r
					toastService.showSuccessToast("Update Successful")
				},
				e => toastService.showErrorToast(e))
		}
	},
	mounted(){
  	officeService.getOfficeList(r => this.officeList = r , e => toastService.showErrorToast(e))
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
